import * as types from './mutation-types'

export default {
  [types.LOAD_NATIONALITIES](state, data) {
    state.nationalities = data
  }
}
